import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import {
  BoldButton,
  ItalicButton,
  LinkButton,
  OrderedListButton,
  UnlinkButton,
  UnorderedListButton,
} from "./MenuButtons";

MenuBar.propTypes = {
  editor: PropTypes.object,
  menuButtons: PropTypes.array.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function MenuBar({
  editor,
  menuButtons,
  style,
  disabled = false,
}) {
  if (!editor) {
    return null;
  }

  const renderButtons = () => {
    return menuButtons.map((buttonType) => {
      switch (buttonType) {
        case "bold":
          return <BoldButton key="bold" editor={editor} disabled={disabled} />;
        case "italic":
          return (
            <ItalicButton key="italic" editor={editor} disabled={disabled} />
          );
        case "ul":
          return (
            <UnorderedListButton key="ul" editor={editor} disabled={disabled} />
          );
        case "ol":
          return (
            <OrderedListButton key="ol" editor={editor} disabled={disabled} />
          );
        case "link":
          return <LinkButton key="link" editor={editor} disabled={disabled} />;
        case "unlink":
          return (
            <UnlinkButton key="unlink" editor={editor} disabled={disabled} />
          );
        default:
          throw new Error("Invalid FnrTextEditor menu button specified!");
      }
    });
  };

  return <Wrapper style={style}>{renderButtons()}</Wrapper>;
}

const Wrapper = styled.div`
  background: #e3e3e3;
  border-bottom: none;
  border-radius: 5px;
  padding: 5px;
`;
